module.exports = __webpack_public_path__ + "1791188489487/images/europe.4d55246.png";